import DonutRaceChart from './DonutRaceChart'
import useRedux from '../../../hooks/useRedux'
import useTranslations from '../../../hooks/useTranslations'
import ANTDCard from '../../../shared/antd/ANTDCard'
import ANTDColumn from '../../../shared/antd/ANTDColumn'
import ANTDProgress from '../../../shared/antd/ANTDProgress'
import ANTDRow from '../../../shared/antd/ANTDRow'
import { isEqual } from '../../../utils/javascript'
import SankeyCharts from '../../charts/SankeyCharts'

const AutomobileTrace = () => {
  const { t } = useTranslations()
  const { selector } = useRedux()
  const activeTab = selector(state => state?.inventory?.activeTab)
  const { materialType } = { ...activeTab }

  return (
    <>
      <ANTDRow gutter={10}>
        <ANTDColumn xs={24} md={8}>
          <DonutRaceChart
            title={t('inv_MaterialComposition')}
            dataSeries={[
              [t('job_Steel'), 70],
              [t('dash_Others'), 5],
              [t('job_Plastic'), 20],
              [t('job_Aluminium'), 5],
            ]}
          />
        </ANTDColumn>
        <ANTDColumn xs={24} md={8}>
          <ANTDCard
            className="no-data-chart d-flex justify-center"
            bordered={false}
            style={{ minHeight: 0 }}
          >
            <h3 className="mb-20">{t('job_Traceability')}</h3>

            <ANTDProgress
              type={'circle'}
              size={180}
              strokeWidth={9}
              percent={90}
              strokeColor="#547a1d"
            />
          </ANTDCard>
        </ANTDColumn>
        <ANTDColumn xs={24} md={8}>
          <ANTDCard
            className="no-data-chart d-flex justify-center"
            bordered={false}
            style={{ minHeight: 0 }}
          >
            <h3 className="mb-20">{t('inv_Circularity')}</h3>

            <ANTDProgress
              type={'circle'}
              size={180}
              strokeWidth={9}
              percent={70}
              strokeColor="#547a1d"
            />
          </ANTDCard>
        </ANTDColumn>
      </ANTDRow>
      <h2 className="content-title mt-20">{t('job_Traceability')}</h2>
      <div
        className={`chart-content ${
          isEqual(materialType, 'bumper') ? 'bumper-container' : ''
        }`}
      >
        <SankeyCharts />
      </div>
    </>
  )
}

export default AutomobileTrace
